import React from "react";
import classNames from "classnames";
import "./MainNav.css";

class MainNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navClose: true,
      menuClosed: true,
    }

    this.onClose = this.onClose.bind(this);
  }

  onClose() {   
    this.setState({
      navClose: !this.state.navClose,
    })
    this.setState({
      menuClosed: !this.state.menuClosed,
    })
  }

  render() {
    const { children, className } = this.props;
    const formatting = ["overlay", "clearfix"];
    const classes = classNames("main-nav", formatting, className);

    return(
      <div className={classes}>
        <div className="Logo">
          {children}
        </div>
        {/* <a href="" className="nav-close" onClick={this.onClose}>
          { <span className="hidden">Close</span> }
        </a> */}
        <div id="nav-button" className={this.state.navClose ? "": "open"} onClick={this.onClose} role="presentation">
          <span />
          <span />
          <span />
          <span />
        </div>
        <ul className={this.state.navClose ? "nav-bar-close": "nav-bar"}> 
          <li><a href="/what-is-prog-soc">About</a></li>
          <li><a href="/events">Events</a></li>
          <li><a href="/partner-with-us">Partner with us</a></li>
          <li><a href="/contact-us">Contact</a></li>
          <li><a href="https://activateuts.com.au/clubs/programmers-society-progsoc" rel="noopener noreferrer" target="_blank"> Join Us!</a></li>
        </ul>
      </div>
      
    ); 
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/layouts/MainNav/MainNav.jsx